import { useEffect } from 'react';
import styles from './styles.module.css';
import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

import Loading from '../../../../Utils/Loading';

import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

import useMediaQuery from '@mui/material/useMediaQuery';

// Toolbar Icons
import arrowBack from '../../../../Shared/Images/atras-icon.png';
import backPage from '../../../../Shared/Images/back.png';
import { useNavigate } from 'react-router-dom';

// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

interface data {
  zIndex: number;
  link: string;
}

function PDFView(props: data) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const [numPages, setNumPages] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [linkPdf, setLinkPdf] = useState<any>('');
  const matches = useMediaQuery('(max-width: 650px)');
  const [numZoom, setNumZoom] = useState<number>(1);

  const navigate = useNavigate();

  const onDocumentLoadSuccess = ({ numPages }: any) => {
    setNumPages(numPages);
  };

  useEffect(() => {
    if (localStorage.getItem('linkPdf')) {
      setLinkPdf(localStorage.getItem('linkPdf'));
    }
  }, []);

  useEffect(() => {
    matches && setNumZoom(0.65);
  }, [matches]);

  function zoom() {
    if (numZoom === 8) {
      return;
    }
    if (numZoom > 0 && numZoom < 8) {
      setNumZoom(numZoom + 0.1);
    }
  }

  function zoomOut() {
    if (numZoom === 0.1) {
      return;
    }
    if (numZoom > 0 && numZoom <= 8) {
      setNumZoom(numZoom - 0.1);
    }
  }

  const goToPrevPage = () => setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);

  const goToNextPage = () =>
    setPageNumber(pageNumber + 1 >= numPages ? numPages : pageNumber + 1);

  
  return (
    <div className={styles.containerAll}>
      <div className={styles.containerToolbar}>
        <div className={styles.firstContainerT}>
          <div
            className={styles.itemToolbar}
            onClick={() => {
              // if (localStorage.getItem('ruta')) {
                navigate(-1);
              // }
            }}
          >
            <img style={{ height: '20px' }} src={arrowBack} alt="img-back" />
          </div>
        </div>
        <div className={styles.secondContainerT}>
          <div className={styles.itemToolbarPagination}>
            <div>{/* <p className="m-0">Página</p> */}</div>
            <div className="flex">
              <div
                className={styles.pagination}
                onClick={goToPrevPage}
                style={{ borderRadius: '7px 0px 0px 7px' }}
              >
                <img style={{ height: '12px' }} src={backPage} alt="back-page" />
              </div>
              <div>
                <p className={styles.pagination}>{pageNumber}</p>
              </div>
              <div
                className={styles.pagination}
                onClick={goToNextPage}
                style={{ borderRadius: '0px 7px 7px 0px' }}
              >
                <img
                  style={{ height: '12px', transform: 'scaleX(-1)' }}
                  src={backPage}
                  alt="back-page"
                />
              </div>
            </div>

            <div>
              <p className="m-0">de {numPages}</p>
            </div>
          </div>
          <div className="flex">
            <div className={styles.itemToolbar}>
              <ZoomInIcon
                onClick={() => zoom()}
                sx={{ cursor: 'pointer' }}
                fontSize="medium"
              />
            </div>
            <div className={styles.itemToolbar}>
              <ZoomOutIcon
                onClick={() => zoomOut()}
                sx={{ cursor: 'pointer' }}
                fontSize="medium"
              />
            </div>
            {/* <a href={linkPdf} target="_blank" rel="noopener noreferrer">
              <button className={styles.btnDescargar}>Descargar</button>
            </a> */}
          </div>
        </div>
      </div>

      {linkPdf ? (
        <div className={`${styles.containerPDF}`} style={{ margin: 'auto' }}>
          <Document file={linkPdf} onLoadSuccess={onDocumentLoadSuccess}>
            <Page scale={numZoom} pageNumber={pageNumber} />
          </Document>
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
}

export default PDFView;
